import { memoize } from './memoize.mjs';

const dateTimeFormat = memoize(
  (...args) => {
    return new Intl.DateTimeFormat(...args);
  }
);
const relativeTimeFormat = memoize(
  (...args) => {
    return new Intl.RelativeTimeFormat(...args);
  }
);
const listFormat = memoize(
  (...args) => {
    return new Intl.ListFormat(...args);
  }
);
const numberFormat = memoize(
  (...args) => {
    return new Intl.NumberFormat(...args);
  }
);

export { dateTimeFormat, listFormat, numberFormat, relativeTimeFormat };
//# sourceMappingURL=intl.mjs.map
